import React, { useState } from "react";
import styled from "styled-components";

// component
import { DynamicButton, StyledText } from "./basic";

const RegionCitySelector = ({ sendLocation, title }) => {
  const regions = [
    { label: "Greater Accra Region", value: 0 },
    { label: "Ashanti Region", value: 1 },
    { label: "Western Region", value: 2 },
    { label: "Central Region", value: 3 },
    { label: "Eastern Region", value: 4 },
    { label: "Bono Region", value: 5 },
    { label: "Volta Region", value: 6 },
    { label: "Northern Region", value: 7 },
    { label: "Upper East Region", value: 8 },
    { label: "Upper West Region", value: 9 },
    { label: "Bono East Region", value: 10 },
    { label: "Western North Region", value: 11 },
    { label: "Oti Region", value: 12 },
    { label: "Ahafo Region", value: 13 },
  ];

  const cities = [
    [
      { label: "Achimota", value: 0 },
      { label: "37 Shell", value: 1 },
      { label: "Accra Central", value: 2 },
      { label: "Accra Mall", value: 3 },
      { label: "Akweteyman", value: 4 },
      { label: "Ashaiman", value: 5 },
      { label: "Circle", value: 6 },
      { label: "Dansoman", value: 7 },
      { label: "Darkuman", value: 8 },
      { label: "East Legon", value: 9 },
      { label: "Haatso", value: 10 },
      { label: "Junction Mall", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy", value: 13 },
      { label: "Motorway Extension", value: 14 },
      { label: "NIA", value: 15 },
      { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Tema 1", value: 19 },
      { label: "Tema 25", value: 20 },
      { label: "Tema 6", value: 21 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "Osu", value: 25 },
      { label: "Ridge", value: 26 },
      { label: "Newtown", value: 27 },
      { label: "Dzorwulu", value: 28 },
      { label: "Ada", value: 29 },
    ],
    [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Bantama", value: 4 },
      { label: "Bibiani", value: 5 },
      { label: "Kejetia", value: 6 },
      { label: "KNUST", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Kumasi City Mall", value: 9 },
      { label: "Mampong", value: 10 },
      { label: "Nhyiaeso", value: 11 },
      { label: "Obuasi", value: 12 },
      { label: "Suame", value: 13 },
      { label: "Tafo", value: 14 },
    ],
    [
      { label: "Essiama", value: 0 },
      { label: "Takoradi Main", value: 1 },
      { label: "Takoradi Mall", value: 2 },
      { label: "Takoradi MC", value: 3 },
      { label: "Tarkwa", value: 4 },
      { label: "Bogoso", value: 5 },
    ],
    [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
      { label: "Assin Fosu", value: 4 },
      { label: "Agona Swedru", value: 5 },
    ],
    [
      { label: "Atimpoku", value: 0 },
      { label: "Akropong", value: 11 },
      { label: "Donkorkrom", value: 1 },
      { label: "Koforidua", value: 2 },
      { label: "New Abirem", value: 3 },
      { label: "Asamankese", value: 4 },
      { label: "Akim Oda", value: 5 },
      { label: "Suhum", value: 6 },
      { label: "Nkawkaw", value: 7 },
      { label: "Osino", value: 8 },
      { label: "Nsawam", value: 9 },
      { label: "Somanya", value: 10 },
    ],
    [
      { label: "Sunyani", value: 0 },
      { label: "Berekum", value: 1 },
      { label: "Dormaa", value: 2 },
    ],
    [
      { label: "Ho", value: 0 },
      { label: "Aflao", value: 1 },
      { label: "Hohoe", value: 2 },
    ],
    [
      { label: "Tamale Kaladan", value: 0 },
      { label: "Tamale", value: 1 },
      { label: "Bimbilla", value: 2 },
      { label: "Yendi", value: 3 },
    ],
    [
      { label: "Bolga", value: 0 },
      { label: "Bawku", value: 1 },
      { label: "Navrongo", value: 2 },
    ],
    [{ label: "Wa", value: 0 }],
    [
      { label: "Techiman", value: 0 },
      { label: "Atebubu", value: 1 },
      { label: "Kintampo", value: 2 },
    ],
    [
      { label: "Enchi", value: 0 },
      { label: "Sefwi Dwenase", value: 1 },
      { label: "Sefwi Juaboso", value: 2 },
    ],
    [
      { label: "Nkwanta", value: 0 },
      { label: "Kete-Krachi", value: 1 },
    ],
    [{ label: "Goaso", value: 0 }],
  ];

  const [selectedRegion, setSelecedRegion] = useState("Greater Accra Region");

  const [seletedRegionIndex, setSeletedRegionIndex] = useState(0);
  const [selectedCity, setSelectedCity] = useState("Achimota");

  return (
    <ModalHolder>
      <div
        style={{
          background: "#fff",
          position: "relative",
          padding: "30px",
          maxWidth: "480px",
          width: "90%",
          boxSizing: "border-box",
          textAlign: "center",
          borderRadius: "15px",
          fontFamily: "MTNRegular",
        }}
      >
        <InputHolder>
          <StyledText>{title}</StyledText>
          <select
            onChange={({ target }) => {
              const { value } = target;

              const values = value.split("/");

              const index = parseInt(values[0]);

              if (value !== null) {
                setSeletedRegionIndex(index);
                setSelecedRegion(values[1]);
                setSelectedCity(cities[index][0].label);
              } else {
                setSeletedRegionIndex(index);
              }
            }}
            placeholder='Please select an option'
            style={{
              borderRadius: 5,
              marginBottom: 20,
              fontFamily: "MTNRegular",
              padding: 10,
              width: 200,
              height: 45,
              backgroundColor: "white",
            }}
          >
            {regions.map((item, index) => {
              const { label, value } = item;
              return (
                <option key={index} label={label} value={`${value}/${label}`}>
                  {label}
                </option>
              );
            })}
          </select>
          <select
            options={cities[seletedRegionIndex]}
            values={[]}
            onChange={({ target }) => {
              const { value } = target;

              const values = value.split("/");

              // const index = parseInt(values[0]);

              setSelectedCity(values[1]);
            }}
            placeholder='Please select an option'
            style={{
              borderRadius: 5,
              marginBottom: 20,
              fontFamily: "MTNRegular",
              padding: 10,
              width: 200,
              height: 45,
              backgroundColor: "white",
            }}
          >
            {cities[seletedRegionIndex].map((item, index) => {
              const { label, value } = item;

              return (
                <option key={index} value={`${value}/${label}`}>
                  {label}
                </option>
              );
            })}
          </select>
        </InputHolder>
        <DynamicButton
          onClick={() => {
            if (selectedRegion && selectedCity)
              sendLocation(selectedRegion, selectedCity);
          }}
          color={"#ffcc00"}
          label={"OK"}
        />
      </div>
    </ModalHolder>
  );
};

const ModalHolder = ({ children }) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default RegionCitySelector;

const InputHolder = styled.div``;
